import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from './api.service';

export type ProjectListView = 'card' | 'list';
const STORAGE_KEY = 'projectListView';

@Injectable({ providedIn: 'root' })
export class ProjectListViewService {
  private readonly api = inject(ApiService);

  readonly view = signal<ProjectListView>(this.loadCached());

  syncFromProfile(preference: string | null | undefined): void {
    const pref: ProjectListView = preference === 'list' ? 'list' : 'card';
    this.view.set(pref);
    localStorage.setItem(STORAGE_KEY, pref);
  }

  setView(mode: ProjectListView): void {
    this.view.set(mode);
    localStorage.setItem(STORAGE_KEY, mode);
    this.api.patch('/api/profile', { project_list_view: mode }).subscribe();
  }

  private loadCached(): ProjectListView {
    const s = localStorage.getItem(STORAGE_KEY);
    return s === 'list' ? 'list' : 'card';
  }
}
